import type { Locale } from '../i18n/LocaleContext'

export interface RouteDefinition {
  path: string
  labelKey: 'home' | 'about' | 'activities' | 'contact'
}

export const navRoutes: Record<Locale, RouteDefinition[]> = {
  hu: [
    { path: '/hu', labelKey: 'home' },
    { path: '/hu/rolunk', labelKey: 'about' },
    { path: '/hu/tevekenysegek', labelKey: 'activities' },
    { path: '/hu/kapcsolat', labelKey: 'contact' },
  ],
  ro: [
    { path: '/ro', labelKey: 'home' },
    { path: '/ro/despre', labelKey: 'about' },
    { path: '/ro/activitati', labelKey: 'activities' },
    { path: '/ro/contact', labelKey: 'contact' },
  ],
}

export function getContactPath(locale: Locale): string {
  return locale === 'hu' ? '/hu/kapcsolat' : '/ro/contact'
}

export function getActivitiesPath(locale: Locale): string {
  return locale === 'hu' ? '/hu/tevekenysegek' : '/ro/activitati'
}

export function getHomePath(locale: Locale): string {
  return `/${locale}`
}

export function getAboutPath(locale: Locale): string {
  return locale === 'hu' ? '/hu/rolunk' : '/ro/despre'
}

export function getTermsPath(locale: Locale): string {
  return locale === 'hu' ? '/hu/feltetelek' : '/ro/termeni'
}

export function getPrivacyPath(locale: Locale): string {
  return locale === 'hu' ? '/hu/adatvedelem' : '/ro/confidentialitate'
}

export function getCookiePath(locale: Locale): string {
  return locale === 'hu' ? '/hu/cookie-szabalyzat' : '/ro/politica-cookies'
}

export function getRegistrationPath(locale: Locale): string {
  return locale === 'hu' ? '/hu/beiratkozas' : '/ro/inscriere'
}

export function getPaymentResultPath(locale: Locale): string {
  return locale === 'hu' ? '/hu/fizetes-eredmeny' : '/ro/rezultat-plata'
}
